import React from 'react';
import {Picker} from 'antd-mobile';
import {DownOutline} from 'antd-mobile-icons';
import {useTranslation} from 'react-i18next';
import useDspWarehouseStore from '../store/dspWarehouseStore';

interface DspWarehouseSelectorProps {
}

const DspWarehouseSelector: React.FC<DspWarehouseSelectorProps> = () => {
    const {warehouses, selectedWarehouseId, setSelectedWarehouseId} = useDspWarehouseStore();
    const [pickerVisible, setPickerVisible] = React.useState(false);

    if (warehouses.length <= 0) {
        return null;
    }

    const canSelect = warehouses.length > 1;

    const pickerColumns = [
        warehouses.map((w) => ({
            label: w.name,
            value: w.id,
        })),
    ];

    const selectedWarehouse = warehouses.find((w) => w.id === selectedWarehouseId);
    const displayName = selectedWarehouse?.name || '';

    return (
        <>
        <span
            className={`inline-flex items-center gap-0.5 ${canSelect ? 'cursor-pointer' : 'cursor-default'}`}
            onClick={canSelect ? () => setPickerVisible(true) : undefined}
        >
          <span>{displayName}</span>
            {canSelect && <DownOutline className="text-gray-500" fontSize={12}/>}
        </span>
            {canSelect && (
                <Picker
                    columns={pickerColumns}
                    visible={pickerVisible}
                    onClose={() => setPickerVisible(false)}
                    value={selectedWarehouseId ? [selectedWarehouseId] : []}
                    onConfirm={(val) => {
                        if (val[0]) {
                            setSelectedWarehouseId(val[0] as string);
                        }
                    }}
                />
            )}
        </>
    );

};

export default DspWarehouseSelector;
